<script lang="ts">
	import heroImageXs from "@assets/images/fathers-family-club-hero.jpg?webp&h=1000&quality=95&imagetools";
	import heroImageSm from "@assets/images/fathers-family-club-hero.jpg?webp&h=1300&quality=95&imagetools";
	import heroImageLg from "@assets/images/fathers-family-club-hero.jpg?webp&h=1600&imagetools";
	import heroImageXl from "@assets/images/fathers-family-club-hero.jpg?webp&h=1900&imagetools";
	import heroImage3xl from "@assets/images/fathers-family-club-hero.jpg?webp&imagetools";
	import clubLogo from "@assets/images/fathers-family-club.png?webp&w=600&imagetools";
	import giftHeroImageXs from "@assets/images/gift-subscription-hero.jpg?webp&h=1000&quality=95&imagetools";
	import giftHeroImageSm from "@assets/images/gift-subscription-hero.jpg?webp&h=1300&quality=95&imagetools";
	import giftHeroImageLg from "@assets/images/gift-subscription-hero.jpg?webp&h=1600&imagetools";
	import giftHeroImageXl from "@assets/images/gift-subscription-hero.jpg?webp&h=1900&imagetools";
	import giftHeroImage3xl from "@assets/images/gift-subscription-hero.jpg?webp&imagetools";
	import giftLogoCs from "@assets/images/gift-subscription-logo-cs.png?webp&w=900&imagetools";
	import giftLogoEn from "@assets/images/gift-subscription-logo-en.png?webp&w=900&imagetools";
	import BuildYourSubscriptionButton from "@components/BuildYourSubscriptionButton.svelte";
	import GiftSubscriptionButton from "@components/GiftSubscriptionButton.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import HandwrittenBanner from "@components/sections/HandwrittenBanner.svelte";
	import { clarityEvent } from "@utils/clarity.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { Locale } from "@core/schema/Locale.js";
	import { getGiftSubscriptionPath } from "@core/schema/paths/getGiftSubscriptionPath.js";
	import { getSubscriptionPagePath } from "@core/schema/paths/getSubscriptionPagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./IntroSections.translations.json" with { type: "json" };

	const giftLetteringLocaleMap: Record<Locale, { src: string; width: number; height: number }> = {
		[Locale.cs]: { src: giftLogoCs, width: 440, height: 247 },
		[Locale.en]: { src: giftLogoEn, width: 440, height: 213 },
	};

	const { tenant } = getGlobalTemplateProps();
	const translate = getTranslate(translations);
</script>

<div class="full-width">
	<div class="grid grid-cols-1 lg:grid-cols-2 w-full bg-fcrdarkbrown">
		<HandwrittenBanner
			lcp
			darkOverlay
			title={translate("heroTitle")}
			tagline={translate("heroTagline")}
			lettering={{ src: clubLogo, width: 300, height: 281 }}
			sources={{
				default: heroImageXs,
				">sm": heroImageSm,
				">lg": heroImageLg,
				">xl": heroImageXl,
				">3xl": heroImage3xl,
			}}
		>
			{#snippet actions()}
				<BuildYourSubscriptionButton
					variant={ButtonVariant.White}
					onclick={(): void => {
						clarityEvent("hpIntroSubscriptionCtaBuild");
					}}
				/>
				<Link
					href={getSubscriptionPagePath(tenant)}
					size={ButtonSize.Medium}
					variant={ButtonVariant.OutlinedWhite}
					onclick={(): void => {
						clarityEvent("hpIntroSubscriptionCtaInfo");
					}}
				>
					<Formatted text={translate("moreInfo")} />
				</Link>
			{/snippet}
		</HandwrittenBanner>
		<HandwrittenBanner
			lcp
			darkOverlay
			title={translate("giftHeroTitle")}
			tagline={translate("giftHeroTagline")}
			lettering={{ ...giftLetteringLocaleMap[tenant.locale], class: "rotate-[3.14deg]" }}
			sources={{
				default: giftHeroImageXs,
				">sm": giftHeroImageSm,
				">lg": giftHeroImageLg,
				">xl": giftHeroImageXl,
				">3xl": giftHeroImage3xl,
			}}
		>
			{#snippet actions()}
				<GiftSubscriptionButton
					variant={ButtonVariant.White}
					onclick={(): void => {
						clarityEvent("hpIntroGiftCtaBuild");
					}}
				/>
				<Link
					href={getGiftSubscriptionPath(tenant)}
					size={ButtonSize.Medium}
					variant={ButtonVariant.OutlinedWhite}
					onclick={(): void => {
						clarityEvent("hpIntroGiftCtaInfo");
					}}
				>
					<Formatted text={translate("moreInfo")} />
				</Link>
			{/snippet}
		</HandwrittenBanner>
	</div>
</div>
